// src/modules/cadete/CadeteDashboard.js
import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react'; 
import { db, paths } from '../../firebase/config';
import {
  doc,
  getDoc,
  addDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  onSnapshot,
  collection,
  query,
  where,
  getDocs,
  runTransaction,
  serverTimestamp,
  Timestamp,
  orderBy,
  limit
} from "firebase/firestore";
import { useAuth, logAuditoria } from '../../context/AuthContext';
import { Modal } from '../../components/Modal';
import { Button } from '../../components/Button';
import { OpcaoCard } from '../../components/OpcaoCard';
import { LoadingSpinner } from '../../components/LoadingSpinner';
import { ChangePasswordModal } from '../../components/ChangePasswordModal';
import { EstagioOpcionalModal } from '../../components/EstagioOpcionalModal'; 
import { RelatorioEstagioModal } from '../../components/RelatorioEstagioModal'; 
import { QueimogramaModal } from '../../components/QueimogramaModal';
import CadeteMap from '../../components/CadeteMap';
import { PesquisaCadetes } from './PesquisaCadetes';
import {
  getCPAName,
  formatarData,
  getNormalizedDateString
} from '../../utils/helpers';

// Dados dos Contatos (Mantidos originais)
const CONTATOS_BATALHOES = [
    { unidade: "CorregPM", telefone: "(11) 3322-0190", email: "corregssi@policiamilitar.sp.gov.br", obs: "Obs.: Pedir para falar com Oficial de permanência" },
    { unidade: "COPOM PM", telefone: "-", email: "copomsrh@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "CPA/M-1", telefone: "(11) 3386-9000", email: "cpam1p3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "7ºBPM/M", telefone: "(11) 3663-0311", email: "7bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "11ºBPM/M", telefone: "(11) 3389-9034", email: "11bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "13ºBPM/M", telefone: "(11) 3222-2833", email: "13bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "CPA/M-2", telefone: "(11) 3546-1305", email: "cpam2divop@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "3ºBPM/M", telefone: "(11) 50731666", email: "3bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "12ºBPM/M", telefone: "(11) 3546-1333", email: "12bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "46ºBPM/M", telefone: "(11) 5061-1243", email: "46bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "CPA/M-3", telefone: "(11) 2287-6317", email: "cpam3secop@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "5ºBPM/M", telefone: "(11) 2201-5292", email: "5bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "9ºBPM/M", telefone: "(11) 2976-1266", email: "9bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "18ºBPM/M", telefone: "(11) 3931-8081", email: "18bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "43ºBPM/M", telefone: "(11) 2959-8022", email: "43bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "CPA/M-4", telefone: "(11) 2023-8140", email: "cpam4divop@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "2ºBPM/M", telefone: "(11) 2023-8157", email: "2bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "29ºBPM/M", telefone: "(11) 2280-6223", email: "29bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "39ºBPM/M", telefone: "(11) 2205-3930", email: "39bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "48ºBPM/M", telefone: "(11) 2521-6312", email: "48bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "CPA/M-5", telefone: "(11) 3769-2011", email: "cpam5divop@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "4ºBPM/M", telefone: "(11) 3834-2411", email: "4bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "16ºBPM/M", telefone: "(11) 3769-2018", email: "16bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "23ºBPM/M", telefone: "(11) 30343533", email: "23bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "49ºBPM/M", telefone: "(11) 3946-1600", email: "49bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "CPA/M-9", telefone: "(11) 2010-9090", email: "cpam9divop@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "19ºBPM/M", telefone: "(11) 2704-6888", email: "19bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "28ºBPM/M", telefone: "(11) 2748-0190", email: "28bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "38ºBPM/M", telefone: "(11) 2731-5888", email: "38bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "CPA/M-10", telefone: "(11) 5641-0811", email: "cpam10secop@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "1ºBPM/M", telefone: "(11) 5852-6171", email: "1bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "22ºBPM/M", telefone: "(11) 5565-5652", email: "22bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "27ºBPM/M", telefone: "(11) 5928-1414", email: "27bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "37ºBPM/M", telefone: "(11) 5821-6617", email: "37bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "50ºBPM/M", telefone: "(11) 5925-6688", email: "", obs: "Batalhão adormecido, abrangido pelo 27ºM" },
    { unidade: "CPA/M-11", telefone: "(11) 2295-3441", email: "cpam11secop@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "8ºBPM/M", telefone: "(11) 2295-6544", email: "8bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "21ºBPM/M", telefone: "(11) 2605-1114", email: "21bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "CPA/M-6", telefone: "(11) 4438-1011", email: "cpam6p3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "6ºBPM/M", telefone: "(11) 4125-1010", email: "6bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "10ºBPM/M", telefone: "(11) 4421-9888", email: "10bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "24ºBPM/M", telefone: "(11) 4057-1010", email: "24bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "30ºBPM/M", telefone: "(11) 4546-3196", email: "30bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "CPA/M-7", telefone: "(11) 2463-5574", email: "cpam7p3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "15ºBPM/M", telefone: "(11) 2463-5536", email: "15bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "26ºBPM/M", telefone: "(11) 4443-6503", email: "26bpmm@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "31ºBPM/M", telefone: "(11) 2467-1534", email: "31bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "CPA/M-8", telefone: "(11) 3686-3120", email: "cpam8divop@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "14ºBPM/M", telefone: "(11) 3681-7107", email: "14bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "20ºBPM/M", telefone: "(11) 4198-3300", email: "20bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "25ºBPM/M", telefone: "(11) 4666-3637", email: "25bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "33ºBPM/M", telefone: "(11) 4169-6218", email: "33bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "36ºBPM/M", telefone: "(11) 47821736", email: "36bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "CPA/M-12*", telefone: "(11) 4725-9000", email: "cpam12p3@policiamilitar.sp.gov.br", obs: "* indisponível para PJ" },
    { unidade: "17ºBPM/M", telefone: "(11) 4721-4548", email: "17bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "32ºBPM/M", telefone: "(11) 4748-8566", email: "32bpmmp3@policiamilitar.sp.gov.br", obs: "" },
    { unidade: "35ºBPM/M", telefone: "(11) 4646-6114", email: "35bpmmp3@policiamilitar.sp.gov.br", obs: "" },
];

const ControlIcon = () => (<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 01-2 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" /></svg>);
const ContactIcon = () => (<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>);
const InfoIcon = () => (<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>);
const MapIcon = () => (<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" /></svg>);
const SearchIcon = () => (<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>);

export const CadeteDashboard = () => {  
  const { userProfile, logoutApp } = useAuth();
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('controle');
  const [loadingQueue, setLoadingQueue] = useState(true); 

  const [currentUserData, setCurrentUserData] = useState(userProfile);
  
  const [pelotaoData, setPelotaoData] = useState(null); 
  const [cadetesPelotao, setCadetesPelotao] = useState([]);
  const [locais, setLocais] = useState([]);
  const [datasEstagio, setDatasEstagio] = useState([]);
  
  // OTIMIZAÇÃO: Separamos o que é Tempo Real do que é Estático
  const [escolhasPelotao, setEscolhasPelotao] = useState([]); // Tempo Real
  const [escolhasGlobalEstatico, setEscolhasGlobalEstatico] = useState([]); // Estático (Carregado no Load)
  
  const [relatorios, setRelatorios] = useState([]); 
  const [allReports, setAllReports] = useState([]); 
  
  const [showModalEscolha, setShowModalEscolha] = useState(false);
  const [showModalImpossibilidade, setShowModalImpossibilidade] = useState(false);
  const [motivoImpossibilidade, setMotivoImpossibilidade] = useState('');
  const [selectedEstagio, setSelectedEstagio] = useState(null); 
  const [selectedDateToSkip, setSelectedDateToSkip] = useState(null); 
  const [contatoSearchTerm, setContatoSearchTerm] = useState('');
  const [error, setError] = useState('');
  const [processing, setProcessing] = useState(false);
  const [reportSuccess, setReportSuccess] = useState('');
  const [whatsappLink, setWhatsappLink] = useState('');
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showNotificarModal, setShowNotificarModal] = useState(false);
  const [proximoCadeteParaNotificar, setProximoCadeteParaNotificar] = useState(null);
  const [loadCheckDone, setLoadCheckDone] = useState(false); 
  const notificationKey = `notification_status_${userProfile.id}`; 
  const prevRoundComplete = useRef(null); 
  const [showModalOpcional, setShowModalOpcional] = useState(false);
  const [showModalRelatorio, setShowModalRelatorio] = useState(false);
  const [escolhaParaRelatorio, setEscolhaParaRelatorio] = useState(null);
  const [relatorioAtual, setRelatorioAtual] = useState(null); 

  const [showQueimogramaModal, setShowQueimogramaModal] = useState(false);
  const [escolhaParaQueimograma, setEscolhaParaQueimograma] = useState(null);

  useEffect(() => {
      if (userProfile?.id) {
          const unsub = onSnapshot(doc(db, paths.users, userProfile.id), (docSnap) => {
              if (docSnap.exists()) {
                  setCurrentUserData({ id: docSnap.id, ...docSnap.data() });
              }
          });
          return () => unsub();
      }
  }, [userProfile?.id]);

  const pelotaoId = currentUserData?.pelotao_id || userProfile?.pelotao_id;

  // 2. OTIMIZAÇÃO: Carregamento de Dados (Híbrido)
  useEffect(() => {
    if (!pelotaoId) {
        setLoading(false);
        setLoadingQueue(false);
        return;
    }
    
    setLoading(true);

    // --- TEMPO REAL ---
    const unsubPelotao = onSnapshot(doc(db, paths.pelotoes, pelotaoId), (docSnap) => {
        if (docSnap.exists()) setPelotaoData(docSnap.data());
    }, (err) => console.error("Erro ao buscar dados do pelotão:", err));

    const qCadetes = query(collection(db, paths.users),
        where("pelotao_id", "==", pelotaoId),
        where("nivel", "in", ["cadete", "escalante", "cadete_academico"])
    );
    const unsubCadetes = onSnapshot(qCadetes, (snapshot) => {
      const lista = snapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .sort((a, b) => a.ordem_antiguidade - b.ordem_antiguidade);
      setCadetesPelotao(lista);
    }, (err) => console.error("Erro ao buscar cadetes:", err));

    // OTIMIZAÇÃO: Tempo Real APENAS no histórico do próprio pelotão
    const qEscolhasPelotao = query(collection(db, paths.escolhas), where("pelotao_id", "==", pelotaoId));
    const unsubEscolhasPelotao = onSnapshot(qEscolhasPelotao, (snapshot) => {
        setEscolhasPelotao(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    }, (err) => console.error("Erro ao buscar escolhas do pelotão:", err));

    const qRelatorios = query(collection(db, paths.relatoriosEstagio), where("cadete_id", "==", userProfile.id));
    const unsubRelatorios = onSnapshot(qRelatorios, (snapshot) => {
        setRelatorios(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    }, (err) => console.error("Erro ao buscar relatórios:", err));

    const qDatas = query(
        collection(db, paths.datasEstagio),
        where("pelotao_id", "in", [pelotaoId, null])
    );
    const unsubDatas = onSnapshot(qDatas, (snapshot) => {
      const listaDatas = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setDatasEstagio(listaDatas);
    }, (err) => console.error("Erro ao buscar datas:", err));

    // --- DADOS ESTÁTICOS (Baixados 1 única vez) ---
    const fetchStaticData = async () => {
        try {
            const locaisSnap = await getDocs(collection(db, paths.locais));
            setLocais(locaisSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));

            // Busca as escolhas globais para ver se as vagas de outros pelotões esgotaram
            const globaisSnap = await getDocs(collection(db, paths.escolhas));
            setEscolhasGlobalEstatico(globaisSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        } catch (err) {
            console.error("Erro ao buscar dados estáticos:", err);
        }
    };

    fetchStaticData();

    return () => { 
        unsubPelotao(); 
        unsubCadetes(); 
        unsubEscolhasPelotao(); 
        unsubRelatorios(); 
        unsubDatas(); 
    };
  }, [pelotaoId, userProfile.id]);

  // Histórico do cadete atual filtrado do array em tempo real do pelotão
  const meuHistorico = useMemo(() => escolhasPelotao.filter(e => e.cadete_id === userProfile.id), [escolhasPelotao, userProfile.id]);

  // --- LÓGICA: LAZY LOADING ESTÁTICO DOS RELATÓRIOS GERAIS ---
  useEffect(() => {
    if (activeTab !== 'informacoes') {
        setAllReports([]); 
        return;
    }

    const fetchReports = async () => {
        try {
            const qAllReports = query(
                collection(db, paths.relatoriosEstagio), 
                orderBy('ultima_atualizacao', 'desc'), 
                limit(100)
            );
            const snapshot = await getDocs(qAllReports); // OTIMIZADO: getDocs em vez de onSnapshot
            const lista = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setAllReports(lista.filter(r => r.cadete && r.cadete.regiao));
        } catch (err) {
            console.error("Erro ao buscar todos relatórios (Lazy Load Estático):", err);
        }
    };

    fetchReports();
  }, [activeTab]);

  useEffect(() => {
    if (cadetesPelotao.length > 0 || datasEstagio.length > 0 || meuHistorico.length > 0) {
        if (loading) setLoading(false);
        if (loadingQueue) setLoadingQueue(false);
    } else if (!pelotaoId) {
        setLoading(false);
        setLoadingQueue(false);
    }
  }, [cadetesPelotao, datasEstagio, meuHistorico, loading, loadingQueue, pelotaoId]);

  const locaisParaMapa = useMemo(() => {
    if (!locais.length || !meuHistorico.length) return [];
    const minhasEscolhasReais = meuHistorico.filter(e => !e.opcao_impossibilidade && e.data && e.local_id);
    return minhasEscolhasReais.map(escolha => {
        const localInfo = locais.find(l => l.id === escolha.local_id);
        if (!localInfo || !localInfo.latitude || !localInfo.longitude) return null;
        return { ...localInfo, data_escolha: escolha.data, tipo_escolha: escolha.tipo };
    }).filter(item => item !== null);
  }, [locais, meuHistorico]);

  const meuUsuarioAoVivo = cadetesPelotao.find(c => c.id === userProfile.id);
  const estouPulado = meuUsuarioAoVivo?.skip_queue === true;
  const isRepeatAllowed = meuUsuarioAoVivo?.allow_repeat_local === true; 

  // =========================================================================================
  // HELPER DE DISPONIBILIDADE OTIMIZADO
  // =========================================================================================
  const mapaVagasOcupadas = useMemo(() => {
    const mapa = {};
    const idsContados = new Set();
    
    // Prioriza as escolhas em tempo real (do próprio pelotão, incluindo externos do pelotão)
    escolhasPelotao.forEach(e => {
        if (!e.opcao_impossibilidade && e.data_estagio_id) {
            mapa[e.data_estagio_id] = (mapa[e.data_estagio_id] || 0) + 1;
            idsContados.add(e.id);
        }
    });

    // Soma as escolhas dos outros pelotões (da busca estática)
    escolhasGlobalEstatico.forEach(e => {
        if (!idsContados.has(e.id) && !e.opcao_impossibilidade && e.data_estagio_id) {
            mapa[e.data_estagio_id] = (mapa[e.data_estagio_id] || 0) + 1;
        }
    });

    return mapa;
  }, [escolhasPelotao, escolhasGlobalEstatico]);

  const getOpcoesValidasParaCadete = useCallback((cadeteId, cadeteHistorico) => {
    if (cadeteHistorico.some(e => e.opcao_impossibilidade && !e.data)) return [];

    const cadeteObj = cadetesPelotao.find(c => c.id === cadeteId);
    if (!cadeteObj) return [];
    
    const locaisUsados = new Set();
    const diasUsados = new Set();
    
    cadeteHistorico.forEach(e => {
        if (e.local_id) locaisUsados.add(e.local_id);
        if (e.data) diasUsados.add(getNormalizedDateString(e.data));
    });

    const allowRepeat = cadeteObj.allow_repeat_local === true;

    return datasEstagio.filter(dt => {
        if (diasUsados.has(getNormalizedDateString(dt.data))) return false;

        if (!allowRepeat && locaisUsados.has(dt.local_id)) return false;

        const vagasTomadas = mapaVagasOcupadas[dt.id] || 0;
        if (dt.tipo === 'PCO') {
             const cap = dt.capacidade || 1;
             if (vagasTomadas >= cap) return false;
        } else {
             if (vagasTomadas >= dt.capacidade) return false;
        }

        return true;
    });
  }, [datasEstagio, mapaVagasOcupadas, cadetesPelotao]);

  // =========================================================================================

  const handleOpenRelatorioModal = (escolha) => {
    const relatorio = relatorios.find(r => r.escolha_id === escolha.id);
    setEscolhaParaRelatorio(escolha); setRelatorioAtual(relatorio); setError(''); setReportSuccess(''); setWhatsappLink(''); setShowModalRelatorio(true);
  };

  const handleSaveRelatorioCadete = async (relatorioData) => {
    if (!escolhaParaRelatorio || processing) return;
    setProcessing(true);
    setError('');
    setReportSuccess(''); 
    try {
        let savedDocId;
        const dataToSave = {
            cadete_id: userProfile.id,
            cadete_nome: userProfile.nome,
            pelotao_id: userProfile.pelotao_id,
            escolha_id: escolhaParaRelatorio.id, 
            data_estagio: escolhaParaRelatorio.data, 
            local_nome: escolhaParaRelatorio.local_nome,
            cadete: relatorioData.cadete, 
            preceptor: relatorioAtual?.preceptor || relatorioData.preceptor, 
            ultima_atualizacao: serverTimestamp(),
        };
        if (relatorioAtual) {
            const docRef = doc(db, paths.relatoriosEstagio, relatorioAtual.id);
            await updateDoc(docRef, dataToSave);
            savedDocId = relatorioAtual.id;
        } else {
            const newDocRef = doc(collection(db, paths.relatoriosEstagio));
            dataToSave.id = newDocRef.id;
            await setDoc(newDocRef, dataToSave);
            savedDocId = newDocRef.id;
            setRelatorioAtual({...dataToSave, id: newDocRef.id});
        }
        setReportSuccess("Relatório salvo com sucesso! Clique em 'Gerar Link' para enviar ao Preceptor.");
    } catch (err) {
        setError(err.message || "Falha ao salvar o relatório.");
    } finally { setProcessing(false); }
  };
  
  const handleGerarLinkPreceptor = (relatorioId) => { 
    if (!relatorioId) { setError("Salve o relatório primeiro."); return; }
    
    const relatorio = relatorios.find(r => r.id === relatorioId);
    const escolha = escolhasPelotao.find(e => e.id === relatorio?.escolha_id);
    
    const preceptorQRA = relatorio?.cadete?.qra_preceptor || 'Preceptor';
    const local = escolha?.local_nome || relatorio?.local_nome || 'Local N/D';
    const data = formatarData(relatorio?.data_estagio || escolha?.data);
    const tipo = escolha?.tipo || 'Estágio';

    const baseUrl = window.location.origin + (process.env.NODE_ENV === 'production' ? '/siaap' : '');
    const linkSimulado = `${baseUrl}/avaliacao-preceptor/${relatorioId}`;
    
    const msgZap = `Permissão, ${preceptorQRA}.\nSegue o link para avaliação do meu estágio de *${tipo}* realizado no *${local}*, dia *${data}*.\n\nLink: ${linkSimulado}`;
    
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    const zapLink = isMobile 
        ? `whatsapp://send?text=${encodeURIComponent(msgZap)}` 
        : `https://web.whatsapp.com/send?text=${encodeURIComponent(msgZap)}`;

    navigator.clipboard.writeText(linkSimulado).then(() => {
        logAuditoria(userProfile, "Geração Link Preceptor", { relatorioId, preceptor: preceptorQRA });
        setReportSuccess(`Link copiado com sucesso! \n\nEste link é para o Oficial Preceptor: ${preceptorQRA}\nReferente ao estágio de ${tipo} no ${local}, dia *${data}*.`);
        setWhatsappLink(zapLink);
    }).catch(err => {
        console.error('Erro ao copiar:', err);
        setError(`Falha ao copiar o link. O link é: ${linkSimulado}`);
    });
  };

  const handleSaveQueimograma = async (dadosAvaliacao) => {
      setProcessing(true);
      setError(''); 
      try {
          const collectionRef = collection(db, paths.queimogramas || "queimogramas");
          await addDoc(collectionRef, {
              escolha_id: escolhaParaQueimograma.id,
              local_id: escolhaParaQueimograma.local_id,
              data_estagio: escolhaParaQueimograma.data,
              avaliacao: dadosAvaliacao,
              respondido_em: serverTimestamp(),
          });
          try {
              const escolhaRef = doc(db, paths.escolhas, escolhaParaQueimograma.id);
              await updateDoc(escolhaRef, { queimograma_realizado: true });
          } catch (updateErr) {
              console.warn("Aviso: O formulário foi salvo, mas houve erro ao atualizar o status na escolha.", updateErr);
          }
          
          setReportSuccess("✅ salvo com sucesso!");
          setShowQueimogramaModal(false);
          setEscolhaParaQueimograma(null);
      } catch (err) {
          console.error("Erro crítico ao salvar:", err);
          setError("Erro ao salvar: " + (err.message || "Verifique sua conexão e tente novamente."));
      } finally {
          setProcessing(false);
      }
  };

  const filaUnificada = useMemo(() => {
    const locais = cadetesPelotao.map(c => ({ ...c, tipo: 'LOCAL', isExterno: false }));
    const externosMap = new Map();
    escolhasPelotao.forEach(e => {
        if (e.tipo === 'EXTERNO') {
            if (!externosMap.has(e.cadete_nome)) {
                const status = e.local_id === 'PENDENTE' ? 'pendente' : 'concluido';
                externosMap.set(e.cadete_nome, { id: e.cadete_id, nome: e.cadete_nome, ordem_antiguidade: e.ordem_externa || 999, telefone: e.cadete_telefone || '', tipo: 'EXTERNO', isExterno: true, status_escolha: status });
            } else {
                const existing = externosMap.get(e.cadete_nome);
                if (e.local_id === 'PENDENTE') existing.status_escolha = 'pendente';
            }
        }
    });
    const externos = Array.from(externosMap.values());
    return [...locais, ...externos].sort((a, b) => a.ordem_antiguidade - b.ordem_antiguidade);
  }, [cadetesPelotao, escolhasPelotao]);

  // =========================================================================================
  // CORE LOGIC: DEFINIÇÃO DE RODADA E OPÇÕES
  // =========================================================================================

  const opcoesDisponiveis = useMemo(() => {
     const rawOptions = getOpcoesValidasParaCadete(userProfile.id, meuHistorico);
     return rawOptions.map(o => {
         const local = locais.find(l => l.id === o.local_id);
         return {
             ...o,
             local_nome: local ? local.nome : 'Desconhecido',
             cpa_nome: local ? getCPAName(local.nome) : 'Outros',
             invalido: null 
         };
     });
  }, [getOpcoesValidasParaCadete, userProfile.id, meuHistorico, locais]);

  const isRoundComplete = useMemo(() => {
      if (datasEstagio.length === 0) return false;
      return opcoesDisponiveis.length === 0;
  }, [datasEstagio, opcoesDisponiveis]);

  const proximoDaFila = useMemo(() => {
      if (datasEstagio.length === 0) return null; 
      if (filaUnificada.length === 0) return null;

      for (const usuario of filaUnificada) {
          if (usuario.skip_queue) continue; 
          
          if (usuario.id === userProfile.id) {
              if (opcoesDisponiveis.length > 0) return usuario;
              continue; 
          }

          if (usuario.isExterno) { 
              if (usuario.status_escolha === 'pendente') return usuario; 
          } else {
              const hist = escolhasPelotao.filter(e => e.cadete_id === usuario.id);
              const opts = getOpcoesValidasParaCadete(usuario.id, hist);
              
              if (opts.length > 0) return usuario;
          }
      }
      return null; 
  }, [filaUnificada, opcoesDisponiveis, userProfile.id, datasEstagio, escolhasPelotao, getOpcoesValidasParaCadete]);

  // =========================================================================================

  const isSystemReleased = pelotaoData?.liberado_escolhas === true;
  const numeroDeEstagiosNormaisFeitos = useMemo(() => meuHistorico.filter(e => !e.opcao_impossibilidade && e.data && !e.opcao_opcional).length, [meuHistorico]);
  const pulouGeralCheck = meuHistorico.some(e => e.opcao_impossibilidade && !e.data);
  const jaInteragiu = meuHistorico.length > 0;
  
  const isMinhaVezNaFila = proximoDaFila?.id === userProfile.id;
  
  const isRoundOpen = isMinhaVezNaFila && !pulouGeralCheck && !isRoundComplete && isSystemReleased && !estouPulado;

  const opcoesAgrupadas = useMemo(() => {
    const grupos = { PCO_POR_DIA: new Map(), PJ_POR_DIA: new Map() };
    const sortedOpcoes = [...opcoesDisponiveis].sort((a, b) => {
      if (a.tipo === 'PCO' && b.tipo === 'PJ') return -1;
      if (a.tipo === 'PJ' && b.tipo === 'PCO') return 1;
      const dateA = a.data?.toDate() || 0;
      const dateB = b.data?.toDate() || 0;
      return dateA - dateB;
    });
    
    const diasEmQueJaEscolhi = new Set(meuHistorico.filter(e => e.data).map(e => getNormalizedDateString(e.data)));

    sortedOpcoes.forEach(opcao => {
      const tipoKey = opcao.tipo; const dataStr = getNormalizedDateString(opcao.data); const cpaKey = opcao.cpa_nome;
      if (tipoKey === 'PCO') {
          if (!grupos.PCO_POR_DIA.has(dataStr)) grupos.PCO_POR_DIA.set(dataStr, { dataTimestamp: opcao.data, dataNome: formatarData(opcao.data), opcoesPorCPA: new Map() });
          const diaGroup = grupos.PCO_POR_DIA.get(dataStr);
          if (!diaGroup.opcoesPorCPA.has(cpaKey)) diaGroup.opcoesPorCPA.set(cpaKey, []);
          diaGroup.opcoesPorCPA.get(cpaKey).push(opcao);
      } else if (tipoKey === 'PJ') {
          if (!grupos.PJ_POR_DIA.has(dataStr)) grupos.PJ_POR_DIA.set(dataStr, { dataTimestamp: opcao.data, dataNome: formatarData(opcao.data), opcoes: [] });
          grupos.PJ_POR_DIA.get(dataStr).opcoes.push(opcao);
      }
    });
    return grupos;
  }, [opcoesDisponiveis, meuHistorico]);
  
  useEffect(() => {
    if (prevRoundComplete.current === null) { prevRoundComplete.current = isRoundComplete; return; }
    if (isRoundComplete && !prevRoundComplete.current) { if (proximoDaFila) { const status = localStorage.getItem(notificationKey); if (status !== "done") { localStorage.setItem(notificationKey, "show_on_load"); setProximoCadeteParaNotificar(proximoDaFila); setShowNotificarModal(true); } } }
    prevRoundComplete.current = isRoundComplete;
  }, [isRoundComplete, proximoDaFila, notificationKey]);

  useEffect(() => { if (proximoDaFila && !loadCheckDone) { const status = localStorage.getItem(notificationKey); if (isRoundComplete && status === "show_on_load") { setProximoCadeteParaNotificar(proximoDaFila); setShowNotificarModal(true); localStorage.setItem(notificationKey, "done"); } setLoadCheckDone(true); } }, [proximoDaFila, isRoundComplete, loadCheckDone, notificationKey]); 

  const handleNotificarProximo = () => { if (!proximoCadeteParaNotificar) return; const telefone = proximoCadeteParaNotificar.telefone; if (!telefone) { alert("Este cadete (externo ou local) não possui telefone cadastrado para notificação."); return; } const numeroLimpo = telefone.replace(/\D/g, ''); const numeroCompleto = '55' + numeroLimpo; const getFirstName = (fullName) => { if (!fullName) return "Cadete"; const parts = fullName.split('(')[0].trim().split(' '); if (parts[0] === 'Cad' && parts[1] === 'PM') return parts[2] || parts[0]; return parts[0]; }; const nomeProximo = getFirstName(proximoCadeteParaNotificar.nome); const nomeRemetente = getFirstName(userProfile.nome); const horaAtual = new Date().getHours(); const saudacao = horaAtual >= 5 && horaAtual < 12 ? "bom dia" : (horaAtual >= 12 && horaAtual < 18 ? "boa tarde" : "boa noite"); const mensagem = `Permissão, ${nomeProximo}, ${saudacao}.\nVocê é o próximo na ordem de antiguidade para realizar a escolha do estágio.\n\nPor gentileza, acesse o sistema e efetue sua escolha o quanto antes.\n\napmbb.com.br/siaap\n\nCaso já tenha efetuado sua escolha, desconsidere esta mensagem.\nTks,\n\n${nomeRemetente}`; window.open(`https://wa.me/${numeroCompleto}?text=${encodeURIComponent(mensagem)}`, '_blank'); localStorage.setItem(notificationKey, "done"); setShowNotificarModal(false); setProximoCadeteParaNotificar(null); };
  const handleCloseNotificarModal = () => { setShowNotificarModal(false); setProximoCadeteParaNotificar(null); };
  const handleSelecionarOpcao = (opcao) => { setSelectedEstagio(opcao); setShowModalEscolha(true); };
  
  const checkAndAutoCloseRound = async (transaction = null) => { 
      await logAuditoria(userProfile, "Interação de Escolha Realizada", { restante: opcoesDisponiveis.length }); 
  };

  const handleConfirmarEscolha = async () => { if (!selectedEstagio || processing) return; setProcessing(true); setError(''); try { await runTransaction(db, async (transaction) => { const qVagas = query(collection(db, paths.escolhas), where("data_estagio_id", "==", selectedEstagio.id), where("opcao_impossibilidade", "==", false)); const vagasSnapshot = await getDocs(qVagas); const dataEstagioRef = doc(db, paths.datasEstagio, selectedEstagio.id); const dataEstagioDoc = await transaction.get(dataEstagioRef); if (!dataEstagioDoc.exists()) throw new Error("Data de estágio não existe mais."); const dataEstagio = dataEstagioDoc.data(); if (dataEstagio.tipo === "PCO" && vagasSnapshot.size > 0) throw new Error("Vaga PCO foi preenchida."); if (dataEstagio.tipo === "PJ" && vagasSnapshot.size >= dataEstagio.capacidade) throw new Error("Vagas PJ esgotaram."); const novaEscolhaRef = doc(collection(db, paths.escolhas)); transaction.set(novaEscolhaRef, { cadete_id: userProfile.id, cadete_nome: userProfile.nome, pelotao_id: pelotaoId, data_estagio_id: selectedEstagio.id, local_id: dataEstagio.local_id, local_nome: selectedEstagio.local_nome, data: dataEstagio.data, tipo: dataEstagio.tipo, turno: dataEstagio.turno, opcao_impossibilidade: false, motivo_impossibilidade: null, criado_em: serverTimestamp() }); const logRef = doc(collection(db, paths.logs)); transaction.set(logRef, { usuario_id: userProfile.id, usuario_nome: userProfile.nome, acao: "Confirmação de Escolha", payload: JSON.stringify({ escolha: selectedEstagio.id, local: selectedEstagio.local_nome }), criado_em: serverTimestamp() }); await checkAndAutoCloseRound(transaction); }); setShowModalEscolha(false); setSelectedEstagio(null); } catch (error) { setError(error.message); } finally { setProcessing(false); } };
  const handleAbrirImpossibilidadePorDia = (d, t) => { setSelectedDateToSkip({ dateString: d, dateTimestamp: t }); setMotivoImpossibilidade(''); setShowModalImpossibilidade(true); };
  const handleConfirmarImpossibilidade = async () => { if (processing) return; setProcessing(true); setError(''); try { await addDoc(collection(db, paths.escolhas), { cadete_id: userProfile.id, cadete_nome: userProfile.nome, pelotao_id: pelotaoId, data_estagio_id: null, local_id: null, local_nome: "IMPOSSIBILIDADE", data: selectedDateToSkip.dateTimestamp, tipo: null, turno: null, opcao_impossibilidade: true, motivo_impossibilidade: motivoImpossibilidade || "Não especificado.", criado_em: serverTimestamp() }); await logAuditoria(userProfile, "Marcou Impossibilidade Por Dia", { data: selectedDateToSkip.dateString, motivo: motivoImpossibilidade }); await checkAndAutoCloseRound(); setShowModalImpossibilidade(false); setSelectedDateToSkip(null); setSelectedEstagio(null); } catch (error) { setError(error.message); } finally { setProcessing(false); } };
  const handleConfirmarEstagioOpcional = async (opcionalData) => { if (processing) return; setProcessing(true); setError(''); try { await addDoc(collection(db, paths.escolhas), { cadete_id: userProfile.id, cadete_nome: userProfile.nome, pelotao_id: pelotaoId, data_estagio_id: null, local_id: null, local_nome: opcionalData.local_nome, data: Timestamp.fromDate(new Date(opcionalData.data + 'T12:00:00Z')), tipo: "OPCIONAL", turno: opcionalData.turno, opcao_impossibilidade: false, opcao_opcional: true, motivo_impossibilidade: opcionalData.motivo, criado_em: serverTimestamp() }); await logAuditoria(userProfile, "Cadastro Estágio Opcional", opcionalData); setShowModalOpcional(false); } catch (error) { setError(error.message); } finally { setProcessing(false); } };

  const StatusEscolha = () => {
    if (loading || loadingQueue) { 
        return (
            <div className="p-4 bg-gray-100 border border-gray-400 text-gray-800 rounded-lg shadow h-full flex flex-col justify-center items-center">
                <div className="animate-spin -ml-1 mr-3 h-8 w-8 text-blue-400" role="status"></div>
                <h3 className="font-bold text-lg text-gray-700 mt-3">Verificando Status...</h3>
                <p className="text-sm mt-1">Carregando dados em tempo real.</p>
            </div>
        );
    }
    
    if (!pelotaoId) return (
      <div className="p-4 bg-yellow-100 border border-yellow-400 text-yellow-800 rounded-lg shadow"><h3 className="font-bold text-lg">Aviso</h3><p>Você não está associado a nenhum pelotão.</p></div>
    );

    if (!isSystemReleased) return (<div className="p-4 bg-gray-100 border border-gray-400 text-gray-800 rounded-lg shadow h-full flex flex-col justify-center animate-pulse"><h3 className="font-bold text-lg text-gray-700">🚫 Aguardando Liberação</h3><p className="text-sm mt-2">O Escalante está preparando a escala ou a rodada está fechada.</p></div>);
    
    if (estouPulado) return (
      <div className="p-4 bg-orange-100 border border-orange-400 text-orange-800 rounded-lg shadow h-full flex flex-col justify-center"><h3 className="font-bold text-lg">⏸️ Você não fará escolhas nesta rodada.</h3><p className="text-sm mt-2">O Escalante colocou você em modo de espera.</p></div>
    );

    const pulouGeral = meuHistorico.some(e => e.opcao_impossibilidade && !e.data);
    if (pulouGeral) return (<div className="p-4 bg-red-100 border border-red-400 text-red-800 rounded-lg shadow"><h3 className="font-bold text-lg">Rodada Pulada</h3><p>Você marcou Impossibilidade Geral.</p></div>);
    
    if (isRoundComplete) return (<div className="p-4 bg-green-100 border border-green-400 text-green-800 rounded-lg shadow"><h3 className="font-bold text-lg">Rodada Concluída!</h3><p>Não há mais opções disponíveis para você nesta rodada.</p></div>);

    if (!proximoDaFila) {
        return (
            <div className="p-4 bg-red-50 border border-red-200 text-red-800 rounded-lg shadow">
                <h3 className="font-bold text-lg">Status Inativo (Diagnóstico)</h3>
                <p className="text-sm mt-2">O sistema não conseguiu montar a fila de escolhas. Possíveis causas:</p>
                <ul className="list-disc pl-5 mt-1 text-sm">
                    {datasEstagio.length === 0 && <li><strong>Não há datas de estágio cadastradas para o seu pelotão ({pelotaoData?.nome || 'Desconhecido'}).</strong> O Escalante precisa criar as vagas.</li>}
                    {cadetesPelotao.length === 0 && <li>Não há outros cadetes no seu pelotão.</li>}
                    <li>Todas as vagas da rodada foram preenchidas.</li>
                </ul>
            </div>
        );
    }

    if (proximoDaFila) {
        if (isMinhaVezNaFila) {
            return (<div className={`p-4 bg-red-100 border border-red-400 text-red-800 rounded-lg shadow animate-pulse`}><h3 className="font-bold text-lg">É A SUA VEZ!</h3><p>Escolha um dos estágios abaixo.</p></div>);
        } else {
            return (<div className="p-4 bg-yellow-100 border border-yellow-400 text-yellow-800 rounded-lg shadow"><h3 className="font-bold text-lg">Aguarde sua vez</h3><p>O próximo a escolher é: <strong>{proximoDaFila.nome}</strong></p></div>);
        }
    }
    
    return (<div className="p-4 bg-gray-100 border border-gray-400 text-gray-800 rounded-lg shadow"><h3 className="font-bold text-lg">Status Inativo</h3></div>);
  };

  const renderOpcoesKanban = () => {
    if (!isSystemReleased) return null;
    if (!isMinhaVezNaFila && !jaInteragiu && proximoDaFila) return <p className="text-gray-500 p-4">Aguardando a sua vez na fila para exibir as opções de escolha.</p>;
    if (opcoesDisponiveis.length === 0 && isRoundOpen) return <p className="text-gray-500">Nenhuma opção disponível.</p>;
    
    const diasInteragidosSet = new Set(meuHistorico.filter(e => e.data).map(e => getNormalizedDateString(e.data)));

    const PCO_ELEMENT = opcoesAgrupadas.PCO_POR_DIA.size > 0 && (
      <div className="p-4 rounded-xl shadow-lg border border-sky-300 bg-sky-50">
          <h4 className="text-2xl font-bold text-sky-800 mb-4 border-b border-sky-300 pb-2">Estágios PCO (Operacional)</h4>
          <div className="flex overflow-x-auto space-x-4 pb-4">
              {[...opcoesAgrupadas.PCO_POR_DIA.entries()].sort(([, a], [, b]) => a.dataTimestamp.toDate() - b.dataTimestamp.toDate()).map(([dataStr, diaGroup]) => (
                    <div key={dataStr} className="flex-shrink-0 w-80 min-w-80">
                        <div className="px-4 py-3 bg-sky-200 rounded-t-lg shadow-sm"><h5 className="font-bold text-sky-900 text-md truncate">{diaGroup.dataNome}</h5></div>
                        <div className="p-2 space-y-3 bg-white border border-sky-200 rounded-b-lg shadow-md">
                          {[...diaGroup.opcoesPorCPA.entries()].map(([cpa, options]) => (<div key={cpa} className="space-y-2 border-b last:border-b-0 pb-2"><p className="text-xs font-semibold text-gray-700 pt-1">{cpa}</p>{options.map(op => (<OpcaoCard key={op.id} opcao={op} handleSelecionarOpcao={handleSelecionarOpcao} todasEscolhas={escolhasPelotao} />))}</div>))}
                            {!diasInteragidosSet.has(dataStr) && (<div className="pt-2 border-t border-gray-100"><Button onClick={() => handleAbrirImpossibilidadePorDia(dataStr, diaGroup.dataTimestamp)} variant="danger" className="w-full text-xs">Marcar Impossibilidade neste Dia</Button></div>)}
                        </div>
                    </div>
              ))}
          </div>
      </div>
    );
    const PJ_ELEMENT = opcoesAgrupadas.PJ_POR_DIA.size > 0 && (
      <div className="p-4 rounded-xl shadow-lg border border-green-300 bg-green-50">
          <h4 className="text-2xl font-bold text-green-800 mb-4 border-b border-green-300 pb-2">Estágios PJ (Jurídica)</h4>
          <div className="flex overflow-x-auto space-x-4 pb-4">
            {[...opcoesAgrupadas.PJ_POR_DIA.entries()].sort(([, a], [, b]) => a.dataTimestamp.toDate() - b.dataTimestamp.toDate()).map(([dataStr, diaGroup]) => (
                    <div key={dataStr} className="flex-shrink-0 w-80 min-w-80">
                        <div className="px-4 py-3 bg-green-200 rounded-t-lg shadow-sm"><h5 className="font-bold text-green-900 text-md truncate">{diaGroup.dataNome}</h5></div>
                        <div className="p-2 space-y-3 bg-white border border-green-200 rounded-b-lg shadow-md">
                            {diaGroup.opcoes.map(op => (<OpcaoCard key={op.id} opcao={op} handleSelecionarOpcao={handleSelecionarOpcao} todasEscolhas={escolhasPelotao} />))}
                            {!diasInteragidosSet.has(dataStr) && (<div className="pt-2 border-t border-gray-100"><Button onClick={() => handleAbrirImpossibilidadePorDia(dataStr, diaGroup.dataTimestamp)} variant="danger" className="w-full text-xs">Marcar Impossibilidade neste Dia</Button></div>)}
                        </div>
                    </div>
            ))}
          </div>
      </div>
    );
    return <div className="space-y-8">{PCO_ELEMENT}{PJ_ELEMENT}</div>;
  };

  const renderInfoTab = () => {
      return (
          <div className="bg-white shadow-md rounded-lg overflow-hidden border border-gray-200">
              <div className="p-4 bg-gray-50 border-b border-gray-200"><h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2"><InfoIcon /> Informações de Relatórios (Todos os Cadetes)</h3><p className="text-sm text-gray-500">Visualize dados compartilhados de outros relatórios.</p></div>
              <div className="overflow-x-auto"><table className="min-w-full divide-y divide-gray-200 text-sm"><thead className="bg-gray-50 text-gray-700 uppercase font-medium"><tr><th className="px-4 py-3 text-left">Região</th><th className="px-4 py-3 text-left">Preceptor (QRA)</th><th className="px-4 py-3 text-left">Telefone</th><th className="px-4 py-3 text-left">Período</th><th className="px-4 py-3 text-left">Indicaria?</th></tr></thead><tbody className="bg-white divide-y divide-gray-200">{allReports.length === 0 ? (<tr><td colSpan="5" className="px-4 py-8 text-center text-gray-500">Nenhum relatório encontrado.</td></tr>) : (allReports.map(report => (<tr key={report.id} className="hover:bg-gray-50 transition-colors"><td className="px-4 py-3 font-medium text-gray-900">{report.cadete?.regiao || report.local_nome || '-'}</td><td className="px-4 py-3 text-gray-600">{report.cadete?.qra_preceptor || '-'}</td><td className="px-4 py-3 text-gray-600">{report.cadete?.telefone_preceptor || '-'}</td><td className="px-4 py-3"><span className={`px-2 py-1 rounded-full text-xs font-semibold ${report.cadete?.periodo === 'noturno' ? 'bg-indigo-100 text-indigo-800' : 'bg-yellow-100 text-yellow-800'}`}>{report.cadete?.periodo || '-'}</span></td><td className="px-4 py-3">{report.cadete?.indicaria_estagio === 'SIM' ? (<span className="text-green-600 font-bold">SIM</span>) : report.cadete?.indicaria_estagio === 'NAO' ? (<span className="text-red-600 font-bold">NÃO</span>) : (<span className="text-gray-400">-</span>)}</td></tr>)))}</tbody></table></div>
          </div>
      );
  };

  const renderContatosTab = () => {
      const filteredContatos = CONTATOS_BATALHOES.filter(c => c.unidade.toLowerCase().includes(contatoSearchTerm.toLowerCase()) || c.email.toLowerCase().includes(contatoSearchTerm.toLowerCase()));
      return (
          <div className="bg-white shadow-md rounded-lg overflow-hidden border border-gray-200">
              <div className="p-4 bg-gray-50 border-b border-gray-200 flex flex-col sm:flex-row justify-between items-center gap-4"><div><h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2"><ContactIcon /> Contato Batalhões (P3)</h3><p className="text-sm text-gray-500">Lista de contatos das unidades para estágio.</p></div><div className="w-full sm:w-64"><input type="text" placeholder="Buscar unidade..." value={contatoSearchTerm} onChange={(e) => setContatoSearchTerm(e.target.value)} className="w-full px-4 py-2 border rounded-lg text-sm focus:ring-blue-500 focus:border-blue-500" /></div></div>
              <div className="overflow-x-auto"><table className="min-w-full divide-y divide-gray-200 text-sm"><thead className="bg-gray-50 text-gray-700 uppercase font-medium"><tr><th className="px-4 py-3 text-left w-32">Unidade</th><th className="px-4 py-3 text-left w-40">Telefone (P3)</th><th className="px-4 py-3 text-left">E-mail</th><th className="px-4 py-3 text-left">Observação</th></tr></thead><tbody className="bg-white divide-y divide-gray-200">{filteredContatos.length === 0 ? (<tr><td colSpan="4" className="px-4 py-8 text-center text-gray-500">Nenhuma unidade encontrada.</td></tr>) : (filteredContatos.map((c, idx) => (<tr key={idx} className="hover:bg-gray-50 transition-colors"><td className="px-4 py-3 font-bold text-gray-900">{c.unidade}</td><td className="px-4 py-3 text-gray-600">{c.telefone}</td><td className="px-4 py-3 text-blue-600 hover:underline">{c.email && <a href={`mailto:${c.email}`}>{c.email}</a>}</td><td className="px-4 py-3 text-gray-500 italic">{c.obs}</td></tr>)))}</tbody></table></div>
          </div>
      );
  };

  return (
       <div> 
      <header className="flex justify-between items-center mb-6">
        <div className="flex items-center space-x-4">
          <img src="https://apmbb.com.br/resultados/brasao.png" alt="Brasão APMBB" className="h-12 w-12" />
          <div>
            <h1 className="text-4xl font-bold text-gray-800">Estágios</h1>
            <p className="text-sm text-gray-600">
                Bem-vindo, {currentUserData?.nome || userProfile.nome}{pelotaoData && <span className="block text-xs text-gray-500 font-bold mt-1">Pelotão: {pelotaoData.nome}</span>}
            </p>
          </div>
        </div>
      </header>

      {error && !showModalEscolha && !showModalImpossibilidade && !showModalOpcional && !showModalRelatorio && (
          <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg"><strong>Erro:</strong> {error}<button onClick={() => setError('')} className="ml-4 font-bold float-right">×</button></div>
      )}
      {reportSuccess && (
          <div className="mb-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded-lg"><strong>Sucesso:</strong> <span dangerouslySetInnerHTML={{ __html: reportSuccess.replace(/\n/g, '<br/>') }} /><button onClick={() => setReportSuccess('')} className="ml-4 font-bold float-right">×</button></div>
      )}

      <div className="flex justify-start mb-8">
          <div className="flex space-x-2 bg-white p-2 rounded-2xl shadow-sm border border-gray-200">
              <button onClick={() => setActiveTab('controle')} className={`flex items-center justify-center gap-2 px-6 py-2.5 rounded-xl font-semibold text-sm transition-all duration-200 ease-in-out ${activeTab === 'controle' ? 'bg-blue-600 text-white shadow-md transform scale-105' : 'text-gray-600 hover:bg-gray-100'}`}><ControlIcon /> Controle</button>
              <button onClick={() => setActiveTab('mapa')} className={`flex items-center justify-center gap-2 px-6 py-2.5 rounded-xl font-semibold text-sm transition-all duration-200 ease-in-out ${activeTab === 'mapa' ? 'bg-blue-600 text-white shadow-md transform scale-105' : 'text-gray-600 hover:bg-gray-100'}`}><MapIcon /> Mapa da Região</button>
              <button onClick={() => setActiveTab('contatos')} className={`flex items-center justify-center gap-2 px-6 py-2.5 rounded-xl font-semibold text-sm transition-all duration-200 ease-in-out ${activeTab === 'contatos' ? 'bg-blue-600 text-white shadow-md transform scale-105' : 'text-gray-600 hover:bg-gray-100'}`}><ContactIcon /> Contato Batalhões</button>
              <button onClick={() => setActiveTab('informacoes')} className={`flex items-center justify-center gap-2 px-6 py-2.5 rounded-xl font-semibold text-sm transition-all duration-200 ease-in-out ${activeTab === 'informacoes' ? 'bg-blue-600 text-white shadow-md transform scale-105' : 'text-gray-600 hover:bg-gray-100'}`}><InfoIcon /> Contato CFP</button>
              
              {/* --- NOVA ABA PESQUISA (Apenas para Cadete Acadêmico) --- */}
              {userProfile?.nivel === 'cadete_academico' && (
                  <button onClick={() => setActiveTab('pesquisa')} className={`flex items-center justify-center gap-2 px-6 py-2.5 rounded-xl font-semibold text-sm transition-all duration-200 ease-in-out ${activeTab === 'pesquisa' ? 'bg-blue-600 text-white shadow-md transform scale-105' : 'text-gray-600 hover:bg-gray-100'}`}><SearchIcon /> Pesquisa</button>
              )}
          </div>
      </div>

      <main>
        {activeTab === 'controle' && (
            <div className="space-y-6 animate-fade-in">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="w-full"><StatusEscolha /></div>
                    {numeroDeEstagiosNormaisFeitos >= 6 && (
                        <div className="w-full">
                            <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg shadow h-full flex flex-col justify-center">
                                <h4 className="text-lg font-semibold text-blue-800">Estágio Opcional (Extra)</h4>
                                <p className="text-sm text-gray-700 mt-1 mb-3">Você já cumpriu o mínimo de 6 estágios. Pode cadastrar um opcional.</p>
                                <Button variant="outline" className="border-blue-600 text-blue-700 hover:bg-blue-100 w-full" onClick={() => { setError(''); setReportSuccess(''); setShowModalOpcional(true); }}>Cadastrar Estágio Opcional</Button>
                            </div>
                        </div>
                    )}
                </div>
                {isRoundOpen && isSystemReleased && (
                <div className="p-4 bg-white rounded-lg shadow">
                    <h3 className="text-xl font-semibold mb-4">Opções de Estágio Disponíveis</h3>
                    {renderOpcoesKanban()}
                </div>
                )}
                {pelotaoId && (
                <div className="grid md:grid-cols-2 gap-6">
                    <div className="p-4 bg-white rounded-lg shadow">
                    <h3 className="text-xl font-semibold mb-4">Meu Histórico de Estágios</h3>
                    {meuHistorico.length > 0 ? (
                        <ul className="divide-y divide-gray-200">
                        {[...meuHistorico].sort((a, b) => { const timeA = a.data ? a.data.toDate().getTime() : Infinity; const timeB = b.data ? b.data.toDate().getTime() : Infinity; if (timeA === Infinity && timeB === Infinity) return 0; return timeA - timeB; }).map(e => {
                                const isRealStage = !e.opcao_impossibilidade && e.data;
                                const relatorio = relatorios.find(r => r.escolha_id === e.id);
                                const corStatusRelatorio = relatorio ? (relatorio.preceptor?.posto_nome ? 'text-green-600' : 'text-blue-600') : 'text-gray-500';
                                const statusRelatorio = relatorio ? (relatorio.preceptor?.posto_nome ? 'Relatório Concluído' : 'Relatório Iniciado') : 'Relatório Pendente';
                                
                                const dataEstagio = e.data ? e.data.toDate() : null;
                                const hoje = new Date();
                                const isEstagioPassado = dataEstagio && dataEstagio < hoje;
                                const queimogramaFeito = e.queimograma_realizado === true;

                                return (
                                <li key={e.id} className="py-3 flex justify-between items-start">
                                    <div className="flex-1"> 
                                        {e.opcao_opcional ? (
                                            <div>
                                                <p className="font-semibold text-blue-600">ESTÁGIO OPCIONAL</p>
                                                <p className="text-sm text-gray-700">Local: {e.local_nome} (Turno: {e.turno})</p>
                                                <p className="text-sm text-gray-700">Data: {formatarData(e.data)}</p>
                                                <p className="text-sm text-gray-500 italic">Justificativa: {e.motivo_impossibilidade}</p>
                                            </div>
                                        ) : e.opcao_impossibilidade ? (
                                            <div>
                                                <p className={`font-semibold ${e.data ? 'text-orange-600' : 'text-red-600'}`}>IMPOSSIBILIDADE {e.data ? `(Dia: ${formatarData(e.data)})` : '(Geral)'}</p>
                                                <p className="text-sm text-gray-500">Motivo: {e.motivo_impossibilidade}</p>
                                            </div>
                                        ) : (
                                            <div>
                                                <p className="font-semibold">{e.local_nome} ({e.tipo})</p>
                                                <p className="text-sm text-gray-600">Data: {formatarData(e.data)} - Turno: {e.turno}</p>
                                                <p className={`text-[10px] font-semibold mt-1 ${corStatusRelatorio}`}>{statusRelatorio}</p>
                                            </div>
                                        )}
                                    </div>
                                    {isRealStage && (
                                        <div className="flex flex-col gap-2 items-end ml-4">
                                            {!queimogramaFeito && (
                                                <Button 
                                                    onClick={() => {
                                                        const preceptorNome = relatorio?.cadete?.qra_preceptor || ""; 
                                                        setEscolhaParaQueimograma({ ...e, preceptor_nome: preceptorNome });
                                                        setShowQueimogramaModal(true);
                                                    }}
                                                    className="w-48 text-xs py-1.5 bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white font-bold shadow-sm flex items-center justify-center gap-1"
                                                    title="Avaliação Confidencial do Oficial"
                                                >
                                                    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" /></svg>
                                                    Avaliar preceptor
                                                </Button>
                                            )}
                                            {queimogramaFeito && (
                                                <span className="w-48 text-[10px] text-green-700 font-bold bg-green-100 px-2 py-1.5 rounded border border-green-200 flex items-center justify-center gap-1 shadow-sm select-none">
                                                    <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                                                    Pesquisa Preenchida 
                                                </span>
                                            )}
                                            <Button 
                                                onClick={() => handleOpenRelatorioModal(e)} 
                                                variant={relatorio ? 'outline' : 'success'} 
                                                className="w-48 text-xs py-1.5 flex items-center justify-center"
                                            >
                                                {relatorio ? 'Ver / Editar Relatório' : 'Preencher Relatório'}
                                            </Button>
                                        </div>
                                    )}
                                </li>
                            )})}
                        </ul>
                    ) : (<p className="text-gray-500">Nenhum estágio escolhido ainda.</p>)}
                    </div>
                    <div className="p-4 bg-white rounded-lg shadow">
                    <h3 className="text-xl font-semibold mb-4">Locais de Estágio</h3>
                    {locais.length > 0 ? (<ul className="divide-y divide-gray-200 max-h-60 overflow-y-auto">{locais.map(l => (<li key={l.id} className="py-3 flex justify-between items-center"><div><p className="font-semibold">{l.nome}</p><p className="text-sm text-gray-500">Tipo: {l.tipo}</p></div></li>))}</ul>) : (<p className="text-gray-500">Nenhum local cadastrado.</p>)}
                    </div>
                </div>
                )}
            </div>
        )}

        {activeTab === 'mapa' && (
            <div className="animate-fade-in bg-white p-6 rounded-lg shadow-lg h-full">
                <h3 className="text-xl font-bold text-gray-800 mb-2">Meus Locais de Estágio</h3>
                <CadeteMap locais={locaisParaMapa} />
            </div>
        )}

        {activeTab === 'contatos' && <div className="animate-fade-in">{renderContatosTab()}</div>}
        {activeTab === 'informacoes' && <div className="animate-fade-in">{renderInfoTab()}</div>}

        {/* --- CONTEÚDO DA NOVA ABA PESQUISA --- */}
        {activeTab === 'pesquisa' && userProfile?.nivel === 'cadete_academico' && (
            <div className="animate-fade-in">
                <PesquisaCadetes />
            </div>
        )}

      </main>

      <Modal show={showModalEscolha} onClose={() => !processing && setShowModalEscolha(false)} title="Confirmar Escolha">
        {selectedEstagio && (<div><p className="text-gray-700">Você está prestes a confirmar sua escolha:</p><div className="my-4 p-3 bg-gray-50 rounded-lg border"><p><strong>Local:</strong> {selectedEstagio.local_nome}</p><p><strong>Data:</strong> {formatarData(selectedEstagio.data)}</p><p><strong>Tipo:</strong> {selectedEstagio.tipo} ({selectedEstagio.turno})</p></div><p className="font-semibold">Esta ação não pode ser desfeita.</p>{error && <p className="text-red-600 mt-2">{error}</p>}<div className="flex justify-end gap-3 mt-4"><Button onClick={() => setShowModalEscolha(false)} variant="secondary" disabled={processing}>Cancelar</Button><Button onClick={handleConfirmarEscolha} variant="success" disabled={processing}>{processing ? "Processando..." : "Confirmar Escolha"}</Button></div></div>)}
      </Modal>
      <Modal show={showModalImpossibilidade} onClose={() => !processing && setShowModalImpossibilidade(false)} title={`Marcar Impossibilidade ${selectedDateToSkip ? `(Dia: ${formatarData(selectedDateToSkip.dateTimestamp)})` : '(ERRO)'}`}>
        <div>{selectedDateToSkip ? (<><p className="text-gray-700">Você tem certeza que deseja marcar impossibilidade para o dia **{formatarData(selectedDateToSkip.dateTimestamp)}**?</p><p className="text-sm text-yellow-700 bg-yellow-50 p-2 rounded-md my-3">Atenção: A marcação de Impossibilidade bloqueará você de escolher **apenas este dia**. Você poderá escolher outros dias nesta rodada.</p></>) : (<p className="text-red-600">Erro interno: O botão de impossibilidade geral foi removido. Feche e tente novamente.</p>)}<div className="mt-4"><label htmlFor="motivo" className="block text-sm font-medium text-gray-700">Motivo (Opcional)</label><textarea id="motivo" rows="3" value={motivoImpossibilidade} onChange={(e) => setMotivoImpossibilidade(e.target.value)} className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Ex: Atestado médico, dispensa, etc."></textarea></div>{error && <p className="text-red-600 mt-2">{error}</p>}<div className="flex justify-end gap-3 mt-4"><Button onClick={() => setShowModalImpossibilidade(false)} variant="secondary" disabled={processing}>Cancelar</Button><Button onClick={handleConfirmarImpossibilidade} variant="danger" disabled={processing || !selectedDateToSkip}>{processing ? "Salvando..." : "Confirmar Impossibilidade"}</Button></div></div>
      </Modal>
      <EstagioOpcionalModal show={showModalOpcional} onClose={() => { setShowModalOpcional(false); setError(''); setReportSuccess(''); }} handleConfirmar={handleConfirmarEstagioOpcional} processing={processing} error={error} />
      {escolhaParaRelatorio && (<RelatorioEstagioModal show={showModalRelatorio} onClose={() => { setShowModalRelatorio(false); setWhatsappLink(''); setReportSuccess(''); }} escolha={escolhaParaRelatorio} relatorioExistente={relatorioAtual} handleSaveRelatorio={handleSaveRelatorioCadete} processing={processing} error={error} reportSuccess={reportSuccess} handleGerarLinkPreceptor={handleGerarLinkPreceptor} whatsappLink={whatsappLink} />)}
      <Modal show={showNotificarModal} onClose={handleCloseNotificarModal} title="Rodada Concluída! Avise o Próximo">{proximoDaFila && (<div className="text-center"><p className="text-lg text-gray-700">Parabéns, você concluiu sua rodada de escolhas!</p><p className="my-4">O próximo da fila é: <strong className="text-xl text-blue-700">{proximoDaFila.nome}</strong></p><p className="text-sm text-gray-600 mb-6">Clique no botão abaixo para notificá-lo via WhatsApp e liberar a fila.</p><Button onClick={handleNotificarProximo} variant="success" className="w-full"><svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 inline-block mr-2" viewBox="0 0 20 20" fill="currentColor"><path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 16.5V3a1 1 0 00-1-1h.586l.293.293z" /></svg>Notificar {proximoDaFila.nome.split('(')[0].trim()} (WhatsApp)</Button><Button onClick={handleCloseNotificarModal} variant="secondary" className="w-full mt-3">Fechar (Avisar depois)</Button></div>)}</Modal>
      <ChangePasswordModal show={showChangePasswordModal} onClose={() => setShowChangePasswordModal(false)} userProfile={userProfile} />
      
      {/* --- MODAL DO QUEIMOGRAMA --- */}
      {escolhaParaQueimograma && (
          <QueimogramaModal 
              show={showQueimogramaModal}
              onClose={() => setShowQueimogramaModal(false)}
              escolha={escolhaParaQueimograma}
              onConfirm={handleSaveQueimograma}
              processing={processing}
          />
      )}
    </div>
  );
};